const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/_app/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { css } from "@packages/panda-generated/css";
import { createFileRoute } from "@tanstack/react-router";
import { ReactNode } from "react";
export const Route = createFileRoute("/_app/dashboard")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export const ItemIndex = ({
  title,
  content
}: {
  title: string;
  content: ReactNode;
}) => {
  return <div className={css({
    p: 3,
    borderRadius: "rounded",
    border: "light"
  })}>
      <div className={css({
      fontSize: {
        base: "xs",
        md: "sm"
      },
      color: "text_light",
      mb: 1
    })}>
        {title}
      </div>
      <div className={css({
      fontSize: {
        base: "md",
        md: "lg"
      },
      fontWeight: "bolder"
    })}>
        {content}
      </div>
    </div>;
};